<p-toast></p-toast>
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
<h2 style="text-align: center;">Enfermera</h2>
<div class="container-ficha">
    <p-tabView *ngIf="casoClinico" styleClass="tabview-custom">

        <p-tabPanel header="Ficha">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label for="folio">Folio</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.folio}}</article>
                </div>
                <div class="field col-12 md:col-4">
                    <label for="serie">Fecha</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.fecha | date:'dd/MM/YYYY'}}</article>
                </div>
                <div class="field col-12 md:col-4">
                    <label for="serie">Serie</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.serie}}</article>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="paciente">Paciente</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.paciente}}</article>
                </div>
                <div class="field col-12 md:col-4">
                    <label for="edad">Edad</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.edad}}</article>
                </div>
                <div class="field col-12 md:col-4">
                    <label for="sexo">Sexo</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{ getSexo(casoClinico.sexo)}}</article>
                </div>
                <div class="field col-12 md:col-4">
                    <label for="institucion">Institucion</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.cveInstitucion}}</article>
                </div>
                <div class="field col-12 md:col-8">
                    <label for="hospital">Hospital</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.nomHospital}}</article>
                </div>
                <div class="field col-12 md:col-8">
                    <label for="diagnostico">Diagnostico</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.diagnostico}}</article>
                </div>
                <div class="field col-12 md:col-8">
                    <label for="antecedente">Antecedente</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.antecedente? casoClinico.antecedente: 'Sin antecedentes'}}</article>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Cirugia">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label for="serie">Fecha aplicacion producto </label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        <span
                            *ngIf="casoClinico.fechaAplicacionProducto; else sn_fecha">{{casoClinico.fechaAplicacionProducto
                            | date:'dd/MM/YYYY'}}</span>
                        <ng-template #sn_fecha>
                            <span>Sin información</span>
                        </ng-template>
                    </article>
                </div>
                <div class="field col-12 md:col-8"></div>
                <div class="field col-12 md:col-6">
                    <label for="Uso">Cuerpo</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        <span *ngIf="casoClinico.nomCuerpo; else sn_cuerpo">{{casoClinico.nomCuerpo}}</span>
                    </article>
                    <ng-template #sn_cuerpo>
                        <span>Sin información</span>
                    </ng-template>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="Uso">Uso del Producto</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        <span *ngIf="casoClinico.usosproducto.length > 0; else sn_uso">
                            {{getUsoProducto(casoClinico.usosproducto)}} </span>
                        <ng-template #sn_uso>
                            <span>Sin información</span>
                        </ng-template>
                    </article>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="accion">Acciones</label>
                    <ul *ngFor="let accion of casoClinico.acciones; index as i;">
                        <li>{{accion.descripcion}}</li>
                    </ul>
                </div>
                <div class="field col-12 md:col-6"></div>
                <div class="field col-12 md:col-12">
                    <label for="tratamiento">Tratamiento</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        <span *ngIf="casoClinico.tratamiento; else sn_tratamiento">{{casoClinico.tratamiento}}</span>
                        <ng-template #sn_tratamiento>
                            <span>Sin información</span>
                        </ng-template>
                    </article>

                </div>
                <div class="field col-12 md:col-4">
                    <label for="antibiotico">Antibiotico</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.nomAntibiotico1? casoClinico.nomAntibiotico1: 'Sin Informacion'}}</article>

                </div>
                <div class="field col-12 md:col-4">
                    <label for="Cantidad">Cantidad ml/mg</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.cantidad1?casoClinico.cantidad1:'Sin dato'}}</article>

                </div>
                <div class="field col-12 md:col-4"></div>
                <div class="field col-12 md:col-4">
                    <label for="antibiotico2">2do. Antibiotico</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.nomAntibiotico2?casoClinico.nomAntibiotico2:'Sin Informacion '}}</article>

                </div>
                <div class="field col-12 md:col-4">
                    <label for="cantidad2">Cantidad ml/mg</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.cantidad2?casoClinico.cantidad2: 'Sin dato '}}</article>

                </div>
                <div class="field col-12 md:col-4"></div>
                <div class="field col-12 md:col-4">
                    <label for="antibiotico3"> 3er. Antibiotico</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.nomAntibiotico3? casoClinico.nomAntibiotico3: 'Sin informacion '}}</article>

                </div>
                <div class="field col-12 md:col-4">
                    <label for="cantidad3">Cantidad ml/mg</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.cantidad3?casoClinico.cantidad3: 'Sin dato '}}</article>

                </div>
                <div class="field col-12 md:col-4"></div>
                <div class="field col-12 md:col-12">
                    <label for="observacion">Observaciones</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.observacion?casoClinico.observacion: 'Sin Observacion'}}</article>

                </div>
            </div>


        </p-tabPanel>
        <p-tabPanel header="Productos">
            <div class="formgrid grid">
                <div class="field col-12 md:col-12">
                    <label for="codigos">Códigos</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        <p-table [value]="casoClinico.productos">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Código</th>
                                    <th>Producto</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-producto>
                                <tr>
                                    <td>{{ producto.codigo}}</td>
                                    <td>{{ producto.nomProducto}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage" let-columns>
                                <tr>
                                    <td colspan="2">
                                        Sin códigos
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </article>

                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Documentos">
            <div class="formgrid grid">
                <div class="field col-12 md:col-12">
                    <label for="documentos">Documentos</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        <p-table [value]="casoClinico.documentos">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Descripción</th>
                                    <th>Documento</th>
                                    <th>Acciones</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-documento>
                                <tr>
                                    <td>{{ documento.descDocumento }} </td>
                                    <td><a [href]="urlBack + documento.rutaPublica + '/' + documento.nomDocumento"
                                            target="_blank">{{
                                            documento.originalNomDocumento}}</a> </td>
                                    <td>
                                        <p-button icon="pi pi-trash"
                                            styleClass="p-button-rounded p-button-danger p-button-text"
                                            (click)="deleteSelectedDocumentos(documento.id)"></p-button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage" let-columns>
                                <tr>
                                    <td colspan="2">
                                        Sin Documentos
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </article>

                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Personal">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6">
                    <label for="folio">Medico</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.medico.nom_medico}}</article>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="serie">Enfermero(a)</label>
                    <article
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{casoClinico.enfermera?casoClinico.enfermera.nom_enfermera: 'Sin asignacion de enfermero(a)'}}
                    </article>
                </div>
            </div>
            <div class="card flex justify-content-end">
                <button form="enf-productividad-add-frm" type="button" pButton pRipple label="Imprimir Expediente"
                    icon="pi pi-file" class="mr-2 inline-block" (click)="exportPDF()"
                    [disabled]="idCasoClinico=='0'"></button>
            </div>
        </p-tabPanel>

    </p-tabView>
    <div class="mt-3">
        <p-button type="button" label="Regresar" (click)="regresar()" styleClass="p-button-sm"></p-button>
    </div>
</div>